import * as React from 'react';
import { connect } from 'react-redux';

import { FormField } from 'components/form';
import InputRadio from 'components/inputs/input-radio/InputRadio';

import { __t } from 'utils/language';
import { isRequired } from 'utils/validators';
import { getInputOnChangeHandler } from '../../utils';

import type { CcmCampaignGender } from 'modules/campaigns/components/ccm/types';
import type {
  CcmCampaignFormCreatorlessThunkDispatch as Dispatch,
  StateAsPartOfGlobal
} from '../../types';

type OwnProps = {
  mgsKey: string,
  classNameBase: string
};

type StateProps = {
  gender: null | CcmCampaignGender
};

type DispatchProps = {
  onChangeGender: (g: CcmCampaignGender) => void
};

type Props = OwnProps & StateProps & DispatchProps;

const TargetGroup = ({
  mgsKey,
  classNameBase,
  gender,
  onChangeGender
}: Props): JSX.Element => (
  <FormField
    showRequiredMark
    showValidationIcon={false}
    fontSize="small"
    label={__t(`${mgsKey}.genders.label`)}
    sublabel={__t(`${mgsKey}.genders.sublabel`)}
    labelType="highlighted"
    direction="column"
    validators={[
      isRequired(gender)
    ]}
  >
    <div className={`${classNameBase}__target-group`}>
      <InputRadio
        key="ccm-campaign-form-creatorfull__target-group--women"
        id="ccm-campaign-form-creatorfull__target-group--women"
        label={__t(`${mgsKey}.genders.radios.women`)}
        value="F"
        checked={gender === 'F'}
        labelClassName={`${classNameBase}__target-group-label`}
        onChange={getInputOnChangeHandler(onChangeGender)}
      />
      <InputRadio
        key="ccm-campaign-form-creatorfull__target-group--men"
        id="ccm-campaign-form-creatorfull__target-group--men"
        label={__t(`${mgsKey}.genders.radios.men`)}
        value="M"
        checked={gender === 'M'}
        labelClassName={`${classNameBase}__target-group-label`}
        onChange={getInputOnChangeHandler(onChangeGender)}
      />
    </div>
  </FormField>
);

const mapStateToProps = ({ ccmCampaignFormCreatorless }: StateAsPartOfGlobal): StateProps => ({
  gender: ccmCampaignFormCreatorless.form.gender
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  onChangeGender: gender => dispatch({
    type: 'creatorless-campaign-gender-update',
    payload: {
      gender
    }
  })
});

export default connect(mapStateToProps, mapDispatchToProps)(TargetGroup);
